<template>
  <div class="dialog-scroller">
    <el-form :inline="true" ref="form" size="mini">
      <el-form-item :label="$t('shebeimingcheng')" :required="true" label-width="225px"></el-form-item>
      <el-form-item :label="$t('yonghu')" :required="true" label-width="190px"></el-form-item>
      <el-form-item v-for="(item, index) in list" :key="index" label-width="30px" size="mini">
        <div>
          <el-row>
            <el-col :span="1.5">
              <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)">
              </el-button>
            </el-col>
            <el-col :span="2">
              {{index+1}}
            </el-col>
            <el-col :span="0.8">&nbsp;</el-col>
            <el-col :span="8">
              <yi_cross_select :key="item.tmpId" :component="'web_base_equipment_list'" :max="200" multiple :ids.sync="item.equipmentIds"></yi_cross_select>
            </el-col>
            <el-col :span="3">&nbsp;</el-col>
            <el-col :span="8">
              <yi_cross_select :key="item.tmpId" multiple :component="'web_system_user_list'" :ids.sync="item.userIds"> </yi_cross_select>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <div style="margin-top: 20px">
        <el-col style="padding-left: 15px">
          <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem()">
          </el-button>
        </el-col>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'web_early_warning_management_alert_settings_equipment_user_list',
  props: {
      itemList: {
        type: Array,
        default: [],
      }
    },
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.list = [...this.itemList];
    if(this.list==null || this.list.length === 0){
      this.list.push({
        tmpId: new Date().getTime(),
        equipmentIds: [],
        userIds: []
      })
    }
  },
  methods:{
    addItem() {
      this.list.push({
        tmpId: new Date().getTime(),
        equipmentIds: [],
        userIds: []
      });
    },
    deleteItem(key) {
      this.list = this.list.filter((item, index) => {
        return index !== key
      });
    },
  }
}
</script>
<style scoped="scoped" lang="scss">
._input /deep/ .el-input__inner {
  min-width: 0;
  width: 150px;
}
</style>